import { render, staticRenderFns } from "./CertificadosBase.vue?vue&type=template&id=ba9185d4&"
import script from "./CertificadosBase.vue?vue&type=script&lang=ts&"
export * from "./CertificadosBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports